import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup, 
  signOut ,signInWithRedirect
} from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Firebase config

//Development
const firebaseConfig = {
  apiKey: "AIzaSyBS5YV2H0-K424m6TlDA2eg2fvgAMSmB8k",
  authDomain: "tgh-user.firebaseapp.com",
  projectId: "tgh-user",
  storageBucket: "tgh-user.firebasestorage.app",
  messagingSenderId: "369424539029",
  appId: "1:369424539029:web:dab3df5d986b35e8c7aa9c"
};

//Production
//const firebaseConfig = {
  //apiKey: "AIzaSyDrkxLZCL1oPbKIGgDE8Vc4TdM1MdSCUIw",
  //authDomain: "thegreathimalayas.com",
  //projectId: "tgh-prod-user",
  //storageBucket: "tgh-prod-user.firebasestorage.app",
  //messagingSenderId: "466537069372",
  //appId: "1:466537069372:web:725055ebbdf0685dcd3c39"
//};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();
const storage = getStorage(app);


const googleLogin = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
 
    const user = result.user;


    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      await setDoc(userRef, {
        name: user.displayName,
        email: user.email,
        photoURL: user.photoURL,
        createdAt: new Date(),
      });
      
    } else {
    
    }

    return user;
  } catch (error) {
    console.error("Google Sign-In Error:", error.message);
  }
};


const logout = () => signOut(auth);

export { auth, googleLogin, logout, storage, messaging, getToken, onMessage };
